import { Button, Modal } from 'antd';
import React from 'react';
import { CloseIcon } from '../../assets/icons';
import { Link } from 'react-router-dom';

/**
 *
 * @typedef {object} BankVerificationPendingModalProps
 * @property {boolean} open
 * @property {()=>void} onClose
 * @property {()=>void} onAddNewBank
 *
 * @param {BankVerificationPendingModalProps} props
 */
export const BankVerificationPendingModal = (props) => {
  const { open, onClose, onAddNewBank } = props;

  const onClick = () => {
    onAddNewBank();
  };
  return (
    <Modal open={open} width={524} footer={false} closeIcon={<CloseIcon />} onCancel={() => onClose()} maskClosable={false} centered>
      <div className='text-center mb-48 '>
        <h4 className='success__title mb-16 fw-500'>
          Bank account <strong>pending</strong> verification
        </h4>
        <p className='mb-24 text-taupe w-100 '>
          You have a bank account which is pending verification. Once your bank account is verified, you'll be ready to start trading.
        </p>
        <Link className='underline fw-500' to='/account/payment'>
          View payment methods in account
        </Link>
      </div>

      <Button type='primary' className='ant-btn-primary--alt' block onClick={onClick}>
        Connect New Bank Account
      </Button>
    </Modal>
  );
};
